import { Injectable } from '@angular/core';
import { WELLNESS_OPTIONS } from '@constants/wellness';
import { Store, StoreConfig } from '@datorama/akita';
import { QuoteSession } from '@models/QuoteSession';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'session', resettable: true })
export class QuoteSessionStore extends Store<QuoteSession> {
	constructor() {
		super({ delayPolicyStartDateDays: 0, wellnessOptions: WELLNESS_OPTIONS });
		this.akitaPreUpdate = this.akitaPreUpdate.bind(this);
	}
}
